import { aiCreditScoringCompareSectionData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingCompareSection.module.css'

const AiInRecruitingCompareSection = () => {
  const { title, subtitle, headers, rows } = aiCreditScoringCompareSectionData

  return (
    <section className={`${styles.compareSection} bg-gray-light`}>
      <div className="container">
        <h2 className={styles.compareTitle}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
        <div className="table-responsive">
          <table className="SmarterApproch-table">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="parameter-header custom-header-black"
                >
                  {headers.capability}
                </th>
                <th scope="col" className="custom-header-light">
                  {headers.traditional}
                </th>
                <th scope="col" className="webclues-header custom-header-blue">
                  {headers.aiPowered}
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} className="align-middle">
                  <td className="parameter-cell">
                    <div className="d-flex align-items-center">
                      <span className="parameter-number-badge d-none d-lg-flex">
                        {row.id}
                      </span>
                      <span className="parameter-title">{row.capability}</span>
                    </div>
                  </td>
                  <td className="inhouse-cell">{row.traditional}</td>
                  <td className="webclues-cell">{row.aiPowered}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingCompareSection
